<template>
  <v-card class="content-card left-nav-card" elevation="1">
    <v-layout column>
      <v-btn
        v-for="section in topStaticSections"
        :key="`top-${section.key}`"
        text
        :class="[
          'nav-button',
          'nav-button--section',
          'nav-button--section-top',
          { active: selectedNavKey === section.key }
        ]"
        @click="onSelectStatic(section)"
      >
        <span class="button-text">{{ section.label }}</span>
      </v-btn>

      <!-- 前言模板下拉選單 -->
      <div class="mb-3">
        <v-menu
          :close-on-content-click="true"
          offset-y
          :nudge-width="0"
          ref="prefaceMenu"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              :class="[
                'nav-button',
                'nav-button--preface',
                { active: selectedNavKey && selectedNavKey.startsWith('preface:') }
              ]"
              v-bind="attrs"
              v-on="on"
            >
              <span class="button-text">{{ getPrefaceButtonText() }}</span>
              <v-icon class="dropdown-icon">keyboard_arrow_down</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list dense>
              <v-list-item
                v-for="template in prefaceTemplates"
                :key="template.id"
                @click="onSelectPreface(template)"
                class="dropdown-item"
              >
                <v-list-item-content>
                  <v-list-item-title class="dropdown-title">{{ template.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>

      <div v-for="(item, index) in findingTemplates" :key="index" class="mb-3">
        <v-menu
          :close-on-content-click="true"
          offset-y
          :nudge-width="0"
          ref="findingMenu"
        >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            :class="[
              'nav-button',
              'nav-button--finding',
              { active: selectedNavKey && selectedNavKey.startsWith(`finding:${item.name}`) }
            ]"
            v-bind="attrs"
            v-on="on"
            >
              <span class="button-text">{{ getFindingButtonText(item) }}</span>
              <v-icon class="dropdown-icon">keyboard_arrow_down</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list dense>
              <v-list-item
                v-for="child in item.children"
                :key="child.id"
                @click="onSelectFinding(child, item)"
                class="dropdown-item"
              >
                <v-list-item-content>
                  <v-list-item-title class="dropdown-title">{{ child.name || 'Negative' }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>

      <v-menu
        :close-on-content-click="true"
        offset-y
        :nudge-width="0"
        ref="interventionMenu"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            :class="[
              'nav-button',
              'nav-button--intervention',
              { active: interventionSelection !== null }
            ]"
            v-bind="attrs"
            v-on="on"
          >
          <span class="button-text">{{ getInterventionButtonText() }}</span>
          <v-icon class="dropdown-icon">keyboard_arrow_down</v-icon>
        </v-btn>
      </template>
        <v-card>
          <v-list dense>
            <v-list-item
              v-for="item in interventionTemplates"
              :key="item.id"
              @click="onSelectIntervention(item)"
              class="dropdown-item"
            >
              <v-list-item-content>
                <v-list-item-title class="dropdown-title">{{ item.name }}</v-list-item-title>
              </v-list-item-content>
              </v-list-item>
            </v-list>
        </v-card>
      </v-menu>

      <div class="nav-bottom-group">
        <v-btn
          v-for="section in bottomStaticSections"
          :key="`bottom-${section.key}`"
          text
          :class="[
            'nav-button',
            'nav-button--section',
            { active: selectedNavKey === section.key }
          ]"
          @click="onSelectStatic(section)"
        >
          <span class="button-text">{{ section.label }}</span>
        </v-btn>
      </div>

    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: 'LeftNavigationPanel',
  props: {
    topStaticSections: {
      type: Array,
      required: true,
    },
    bottomStaticSections: {
      type: Array,
      required: true,
    },
    prefaceTemplates: {
      type: Array,
      required: true,
    },
    findingTemplates: {
      type: Array,
      required: true,
    },
    interventionTemplates: {
      type: Array,
      required: true,
    },
    selectedNavKey: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      findingSelections: {},
      interventionSelection: null,
      prefaceSelection: null,
    };
  },
  methods: {
    makeKey(type, name, parent = null) {
      const norm = s => String(s || '').trim();
      const t = norm(type);
      const n = norm(name);
      const p = norm(parent);
      return p ? `${t}:${p}:${n}` : `${t}:${n}`;
    },
    clearFindingSelections(exceptId = null) {
      Object.keys(this.findingSelections).forEach(id => {
        if (String(id) !== String(exceptId)) {
          this.$set(this.findingSelections, id, null);
        }
      });
      // 注意：這裡不應該清除處置模板選中狀態，因為它應該由各自的選擇方法來管理
    },
    onSelectStatic(section) {
      this.$emit('select-static', section);
      this.$set(this, 'interventionSelection', null);
      this.$set(this, 'prefaceSelection', null);
      this.clearFindingSelections();
    },
    onSelectPreface(template) {
      this.$set(this, 'prefaceSelection', template);
      this.$emit('select-preface', template, this.makeKey('preface', template.name));
      this.$set(this, 'interventionSelection', null);
      this.clearFindingSelections();
      // 關閉對應的下拉選單
      this.$nextTick(() => {
        if (this.$refs.prefaceMenu) {
          this.$refs.prefaceMenu.isActive = false;
        }
      });
    },
    onSelectFinding(child, item) {
      this.$set(this.findingSelections, item.id, child);
      this.$emit('select-finding', child, this.makeKey('finding', child.name, item.name));
      // 清除處置模板選中狀態
      this.$set(this, 'interventionSelection', null);
      this.$set(this, 'prefaceSelection', null);
      this.clearFindingSelections(item.id);
      // 關閉對應的下拉選單
      this.$nextTick(() => {
        if (this.$refs.findingMenu && this.$refs.findingMenu[0]) {
          this.$refs.findingMenu[0].isActive = false;
        }
      });
    },
    onSelectIntervention(item) {
      // 使用 $set 確保響應式更新
      this.$set(this, 'interventionSelection', item);
      this.$emit('select-intervention', item, this.makeKey('intervention', item.name));
      this.$set(this, 'prefaceSelection', null);
      this.clearFindingSelections();
      // 關閉對應的下拉選單
      this.$nextTick(() => {
        if (this.$refs.interventionMenu) {
          this.$refs.interventionMenu.isActive = false;
        }
      });
    },
    getInterventionButtonText() {
      if (this.interventionSelection) {
        return `處置模板 (${this.interventionSelection.name})`;
      }
      return '處置模板';
    },
    getPrefaceButtonText() {
      const hasMultiplePrefaceOptions = Array.isArray(this.prefaceTemplates) && this.prefaceTemplates.length > 1;
      if (!hasMultiplePrefaceOptions) {
        return '前言';
      }
      if (this.prefaceSelection) {
        return `前言 (${this.prefaceSelection.name})`;
      }
      return '前言';
    },
    getFindingButtonText(item) {
      if (this.findingSelections[item.id]) {
        return `病灶模板-${item.name} (${this.findingSelections[item.id].name})`;
      }
      return `病灶模板-${item.name}`;
    },
  },
};
</script>

<style scoped>
.left-nav-card {
  background-color: #ffffff;
  border-radius: 10px;
  border: 1px solid #eef1f6;
  box-shadow: 0 1px 3px rgba(18, 38, 63, 0.06);
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.left-nav-card .v-layout {
  height: 100%;
  justify-content: flex-start;
}

.nav-button {
  justify-content: space-between;
  margin-bottom: 1px;
  margin-top: 2px;
  color: #46505a;
  width: 100%;
  min-height: 40px;
  padding: 6px 16px;
  background-color: #f5f5f5;
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
}

.nav-button--section {
  margin-top: 0;
}

.nav-button--section-top {
  margin-bottom: 12px;
}

.nav-button--preface {
  margin-top: 0;
}

.nav-button--finding {
  margin-top: 0;
}

.nav-button--intervention {
  margin-top: 0;
  margin-bottom: 0;
}

.nav-bottom-group {
  margin-top: 12px;
}

.nav-bottom-group .nav-button {
  margin-top: 0;
  margin-bottom: 0;
}

.nav-bottom-group .nav-button + .nav-button {
  margin-top: 12px;
}

.nav-button.active {
  background-color: #e9f3fe;
  color: #1976d2;
}

.button-text {
  flex: 1;
  text-align: left;
}

.dropdown-icon {
  margin-left: 8px;
  color: #666;
}

.dropdown-item {
  padding: 6px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  min-height: 32px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f5f5f5;
}

.dropdown-item:last-child {
  border-bottom: none;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}

.dropdown-title {
  font-size: 13px;
  line-height: 1.3;
  word-wrap: break-word;
  white-space: nowrap;
  color: #333;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
